<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2">
        <div class="input-group input-group-sm master-search-group">
          <input type="text" class="form-control" name="term"
                 placeholder="Consumer Key, ชื่อ API หรือข้อความ"
                 [ngModel]="term()"
                 (ngModelChange)="term.set($event)"/>
          <button class="btn btn-default" type="submit">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <select class="form-select form-select-sm filter-select"
                name="responseCodeCategory"
                [ngModel]="responseCodeCategory()"
                (ngModelChange)="responseCodeCategory.set($event); search()">
          <option value="">- สถานะ HTTP -</option>
          <option value="2xx">2xx : สำเร็จ</option>
          <option value="4xx">4xx : Client Error</option>
          <option value="5xx">5xx : Server Error</option>
        </select>
      </div>
    </form>
  </div>

  <div class="card-subheader px-3 py-2 border-bottom bg-white d-flex align-items-center gap-2">
    <span class="text-body-secondary small">Show</span>
    <app-pagesize-select size="sm" [value]="pageData().page.size"
                         (valueChange)="pageData().page.size = $event; search()"/>
    <span class="text-body-secondary small">entries</span>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap class="text-center">No.</th>
            <th nowrap>Consumer Key</th>
            <th nowrap>ชื่อ API</th>
            <th nowrap>ที่อยู่ไอพี</th>
            <th nowrap>วันเวลาร้องขอ</th>
            <th nowrap>สถานะ HTTP</th>
            <th>ข้อความ</th>
          </tr>
        </thead>
        <tbody>
          @if (pageData()?.content?.length === 0) {
            <tr>
              <td colspan="7" class="text-center py-4 text-body-secondary">- ไม่มีข้อมูล -</td>
            </tr>
          } @else {
            @for (row of pageData()?.content; track row.id; let i = $index) {
              <tr>
                <td class="text-center">{{ (pageData().page?.size * pageData().page?.number) + (i + 1) }}</td>
                <td nowrap>{{ row.consumerKey || '-' }}</td>
                <td>
                  {{ row.apiName || '-' }}
                  @if (row.apiName && apiDescMap()[row.apiName]) {
                    <span class="api-desc text-primary">{{ apiDescMap()[row.apiName] }}</span>
                  }
                </td>
                <td nowrap>{{ row.ip || '-' }}</td>
                <td nowrap>{{ row.logTime | thaidatetime }}</td>
                <td>
                  @if (row.responseCode) {
                    <span class="http-badge"
                          [class.http-badge--success]="statusTone(row.responseCode) === 'success'"
                          [class.http-badge--warn]="statusTone(row.responseCode) === 'warn'"
                          [class.http-badge--danger]="statusTone(row.responseCode) === 'danger'"
                          [class.http-badge--secondary]="statusTone(row.responseCode) === 'secondary'">
                      {{ httpStatusText(row.responseCode) }}
                    </span>
                  } @else {
                    <span class="text-muted">-</span>
                  }
                </td>
                <td>{{ row.message || '-' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <span class="text-body-secondary small">Total {{ pageData().page?.totalElements ?? 0 }} records</span>
    <ngb-pagination [collectionSize]="pageData().page.totalElements"
                    [page]="pageData().page.number + 1"
                    [pageSize]="pageData().page.size"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="search($event)">
    </ngb-pagination>
  </div>
</div>

<div class="alert alert-info alert-dismissible fade show mt-3" role="alert">
  <strong>หมายเหตุ</strong><br/>
  ข้อมูล Log จะถูกเก็บไว้นานสูงสุด 150 วัน
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
